import { useRef } from "react";
import MenuItem from "../../menuItem/MenuItem";
import SubMenuSpecial from "./special/SubMenuSpecial";
import styles from "./subMenuDesktop.module.scss";
import clsx from "clsx";
import { Icon } from "@monta/design-system";
import { Link } from "@monta/router-js";
import { generatPropsTagA } from "../../menuItem/generatPropsTagA";
import type { IMenu } from "../../../../../constants";

interface SubMenuDesktopProps {
  menuItem: IMenu;
}

const SubMenuDesktop = (props: SubMenuDesktopProps) => {
  const { menuItem } = props;
  const menuItemRef = useRef<HTMLDivElement>(null);

  const onBlurItem = () => {
    if (menuItemRef.current) {
      menuItemRef.current.style.display = "none";
      setTimeout(() => {
        if (menuItemRef.current) {
          menuItemRef.current.style.display = "";
        }
      }, 100);
    }
  };

  const propTagA = generatPropsTagA(menuItem);

  const itemValue = (
    <div className={styles["sub-menu__title"]}>
      {menuItem.title}
      {Boolean(menuItem?.childs.linkList) && (
        <Icon
          icon="mi-Arrow-Down"
          size={1}
          className={styles["sub-menu__title__icon"]}
        />
      )}
    </div>
  );

  return (
    <div
      id="subMenuDesktop"
      className={clsx(
        styles["sub-menu"],
        menuItem.showTypeID === 1 && styles["sub-menu--special"],
      )}
      key={menuItem?.linkID}
    >
      {propTagA.href ? (
        <Link
          {...propTagA}
          href={propTagA.href as string}
          id={`menu-item-${menuItem?.linkID}-link`}
        >
          {itemValue}
        </Link>
      ) : (
        <label id={`menu-item-${menuItem?.linkID}-label`}>{itemValue}</label>
      )}

      {menuItem.showTypeID === 1 ? (
        <div
          id={"special-menu-showTypeId1"}
          className={styles["collapse-special-menu"]}
          ref={menuItemRef}
        >
          <SubMenuSpecial
            items={menuItem?.childs.linkList}
            onBlurItem={onBlurItem}
          />
        </div>
      ) : (
        <div className={styles["sub-menu__items"]}>
          <div className={styles["mega-menu"]}>
            {menuItem?.childs?.linkList.map((subMenuHead) => {
              return (
                <div
                  key={subMenuHead.linkID}
                  className={styles["mega-menu__col"]}
                >
                  <div
                    id="subMenuDesktop-child-linklist"
                    className={styles["mega-menu__col__title"]}
                  >
                    {subMenuHead.title}
                  </div>
                  <ul>
                    {subMenuHead?.childs?.linkList.map((subMenuItem) => (
                      <MenuItem
                        menuItem={subMenuItem}
                        className={styles["sub-menu__items__item"]}
                        key={subMenuItem.linkID}
                      />
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
export default SubMenuDesktop;
